<template>
</template>

<script>
export default {
    name : 'TicketWidgetNewButton',

    props : ['widget'],

    watch: {
      widget() {
        this.onWidgetChange();
      }
    },

    mounted() {
      this.onWidgetChange();
    },

    methods : {
      onWidgetChange() {
        $('.TicketNewBtn').fadeIn();
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetNewButton.vue